
import React from 'react';
import { IContextProvider, registerUI } from '@uxp';
import { QueryBuilder } from '@query-builder/QueryBuilder';
import Test from '@query-builder/Test/Test';
import './styles.scss';
import { useQueryEngineService } from '@query-builder/useQueryEngineService';


export interface IUXPDefaultProps {
    uxpContext: IContextProvider
}

(window as any).QueryBuilderComponents = {
    QueryBuilder: QueryBuilder,
    useQueryEngineService: useQueryEngineService
}

registerUI({
    id: "lucy-query-builder",
    component: Test,
    showDefaultHeader: false
});